import { render, staticRenderFns } from "./BillingLink.vue?vue&type=template&id=ec5b7fd8&scoped=true&"
import script from "./BillingLink.vue?vue&type=script&lang=ts&"
export * from "./BillingLink.vue?vue&type=script&lang=ts&"
import style0 from "./BillingLink.vue?vue&type=style&index=0&id=ec5b7fd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5b7fd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
